import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=7c1e3f0c&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c1e3f0c')) {
      api.createRecord('7c1e3f0c', component.options)
    } else {
      api.reload('7c1e3f0c', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=7c1e3f0c&", function () {
      api.rerender('7c1e3f0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppMain.vue"
export default component.exports